import { render, staticRenderFns } from "./funesPresMX.vue?vue&type=template&id=4f948080"
import script from "./funesPresMX.vue?vue&type=script&lang=js"
export * from "./funesPresMX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports